import "./index.scss";
import React from "react";

import Checkbox from "Components/common/Checkbox/Checkbox";
import Sort from "./Sort/Sort";
import TextContaining from "./TextContaining/TextContaining";
import DateRange from "./DateRange/DateRange";
import clsx from 'clsx';
import _ from 'lodash';

class FilterBox extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            searchValue: null,
            searchedFilterOptions: [],
        }
    }

    debouncedHandleSearch = _.debounce(searchValue => {
        const { filterOptions, onSearchFilters } = this.props;

        this.setState(prevState => ({
            ...prevState,
            searchValue,
            searchedFilterOptions: filterOptions.filter(f => 
                f.label.toLowerCase().includes(searchValue)
            )
        }));

        if (onSearchFilters) {
            onSearchFilters(searchValue);
        }
    }, 400)

    handleSearch = e => {
        const searchValue = e.target.value;
        this.debouncedHandleSearch(searchValue)
    }

    render() {
        const { column, filterOptions, filterSelected, isSearchable = false, classes = {}} = this.props;
        const { searchedFilterOptions, searchValue } = this.state;
        const options = searchValue
            ? searchedFilterOptions
            : filterOptions;
        const isAllOptionVisible = !searchValue;
        const { props } = this;

        let  isCheckedAll = filterSelected && filterSelected.filter(f => f.isActive).length === options.length;
        
        if(props.excludeFilter) {
            isCheckedAll = filterSelected && filterSelected.filter(f => f.isActive && f.id !== props.excludeFilter).length > 0 && filterSelected.filter(f => f.isActive && f.id !== props.excludeFilter).length === options.filter(f => f.id !== props.excludeFilter).length;
        }

        const isFilterChecked = (value) => {
            if(filterSelected) {
                const index = filterSelected.map(f => f.id).indexOf(value);
                
                if(index > -1) {
                    return filterSelected[index].isActive; 
                }
            }   

            return false;
        }

        const handleSelectAll = () => {
            if(isCheckedAll) {
                this.props.onUpdateFilters(filterSelected.map(f => ({...f, isActive: false})));
            } else if(!isCheckedAll) {
                this.props.onUpdateFilters(filterSelected.map(f => ({...f, isActive: true, value: ''})));
            }
        }

        const handleSelectFilters = (value) => {
            if(isFilterChecked(value)) {
                this.props.onUpdateFilters([...(filterSelected || []).map(f => {
                    if(f.id === value) {
                        return {...f, isActive: false}
                    }

                    return f;
                })]);
            } else {
                this.props.onUpdateFilters([...(filterSelected || []).map(f => {
                    if(f.id === value) {
                        return {...f, isActive: true, value: ''}
                    }

                    return f;
                })]);
            }
        }

        let hideFilterSection = this.props.hideFilterSection;

        if (this.props.sortingType === 'numerical') {
            hideFilterSection = true;
        }

        return (
            <div class={clsx(`filterBoxContainer`, classes.options)}>
                <Sort 
                    column={column} 
                    sortingType={this.props.sortingType} 
                    sortingSelected={this.props.sortingSelected}
                    onUpdateSorting={this.props.onUpdateSorting}
                />
                {!hideFilterSection && (
                    <div class={clsx(`filterByContainer`, options.filter(f => f.id === "dateRange").length > 0  && 'dateRangeBoxContainer', classes.filterBy)}>
                        <h4>Filter By</h4>
                        {isSearchable && 
                            <div class="searchItems">
                                <input type="text" placeholder='Search' onChange={this.handleSearch} />
                                <i class="material-icons">search</i>
                            </div>
                        }
                        <div class="filterItems">
                            {searchValue && searchedFilterOptions.length < 1 && 
                                <div className="filterItem no-results-found">
                                    No Results Found
                                </div>
                            } 
                            {isAllOptionVisible && 
                                <div class={clsx(`filterItem`, this.props.disableFilters && 'disabled')} >
                                    <div class="filterCheckbox">
                                        <Checkbox value="all" onChange={handleSelectAll} checked={isCheckedAll} />
                                        <span>{this.props.selectAllLabel?this.props.selectAllLabel:'All'}</span>
                                    </div>
                                </div>
                            }
                            {options.map(filter => {
                                if(filter.option) {
                                    if(filter.option === "textContaining") {
                                        return (
                                            <div key={`textContainingFilterKey`} class="filterItem">
                                                <TextContaining 
                                                    filter={filter} 
                                                    filterSelected={this.props.filterSelected}
                                                    onUpdate={this.props.onUpdateFilters}
                                                    onSelect={handleSelectFilters} 
                                                    isChecked={isFilterChecked(filter.id)} 
                                                />
                                            </div>
                                        )
                                    } else if(filter.option === "dateRange") {
                                        return (
                                            <div key={`dateRangeFilterKey`} class="filterItem">
                                                <DateRange 
                                                    filter={filter} 
                                                    filterSelected={this.props.filterSelected}
                                                    onUpdate={this.props.onUpdateFilters}
                                                    onSelect={handleSelectFilters} 
                                                    isChecked={isFilterChecked(filter.id)} 
                                                />
                                            </div>
                                        )
                                    }
                                }

                                return (
                                    <div key={`filterItemKey_${filter.id}`} class={clsx(`filterItem`, filter.class, this.props.disableFilters && 'disabled')}>
                                        <div class="filterCheckbox">
                                            <Checkbox value={filter.id} onChange={handleSelectFilters} checked={isFilterChecked(filter.id)} />
                                            <span>{filter.label}</span>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )}
                <div class="bottomContent">
                    {this.props.bottomContent}
                </div>
            </div>
        )
    }
}

FilterBox.defaultProps = {
    filters: [],
    classes: {}
}

export { FilterBox };